import Api from '../Api';
import { IdObject, ResponseBase } from '../Models';

export enum HistoryRoute { Home, SubHistory, Question }
export const _correctSound = 'sound/correct.mp3';
export const _wrongSound = 'sound/wrong.mp3';
export const _pageSound = 'sound/page.mp3';
export const _resultSound = 'sound/result.mp3';

